import React from 'react';
import { Hint as UIKitHint, helperMargin } from '@utex/ui-kit';
import { Content } from './styles';

interface Props {
  withMargin?: boolean;
}

export const Hint: React.FC<Props> = ({ children, withMargin = true }) => {
  return (
    <UIKitHint view="warning" css={withMargin ? helperMargin({ top: 10 }) : undefined}>
      <Content>{children}</Content>
    </UIKitHint>
  );
};
